import { postHrms, postHrmsMultipart } from "../erpClient";

/**
 * POST /api/hrms — dispatch by `type` (see `sales_targets_hrms_api.md` Part B).
 * @param {string} type
 * @param {Record<string, unknown>} payload
 */
export function hrmsApi(type, payload = {}) {
  return postHrms({ type, ...payload });
}

/** Multipart POST /api/hrms/ — `type` must be set on formData before call. */
export function hrmsMultipart(formData) {
  return postHrmsMultipart(formData);
}
